module.exports = __webpack_public_path__ + "img/icon-fast.20e3bddd.svg";